import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import ComponentListService from '../../services/ComponentListService';
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        // liability: [],
        // assets: [],
        // paymentTerm: [],
        // sequenceFormats: []
    }
};
export const fetchComponent = createAsyncThunk('component', async () => {
    const response = await ComponentListService.getComponentByPage ();
    return response;
});

export const fetchTotalComponents = createAsyncThunk('totalcomponent', async () => {
    const response = await ComponentListService.getTotalComponent();
    return response;
})


export const ComponentSlice = createSlice({
    name: 'component',
    initialState,
    reducers: {
        addComponentColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToComponentColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchComponent.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchComponent.fulfilled, (state, action) => {
            state.status = "idle";
            state.data = action.payload;
          })
          .addCase(fetchTotalComponents.pending, (state) => {
            state.status = "loading";
          })
          .addCase(fetchTotalComponents.fulfilled, (state, action) => {
            state.status = "idle";
            state.data = action.payload;
          });
    }
});

export const { addComponentColumnConfig, addColumnToComponentColumnConfig } =
ComponentSlice.actions;

export const selectComponent = (state) => {

    return state.component.data
};

export const selectComponentColumnConfig = (state) =>
    state.component.columnConfig;

export default ComponentSlice.reducer;